module.exports = __webpack_public_path__ + "src/assets/_textures/petri/guide.jpg";